import React from "react";
import BreadCrumb from "../Components/BreadCrumb";
import { Table } from "react-bootstrap";
import { useGetCalendarDataQuery } from "../../../redux/services/internal/apiHome";
import Spinner from "../Components/Spinner";

const CalendarPage = ({ benchId }) => {
  const {
    data: calendarData,
    isLoading,
    isError,
  } = useGetCalendarDataQuery({ benchId });
  if (isLoading) {
    return <Spinner />;
  }
  return (
    <div className="col-12 col-sm-12 col-md-9 col-lg-9">
      <BreadCrumb title={"Calendar"} />
      <div className="chairman-detail my-4">
        <div className="container">
          <div className="table-responsive">
            <Table striped bordered hover className="custom-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Title</th>
                  <th>Year</th>
                  <th>Documents</th>
                </tr>
              </thead>
              <tbody>
                {calendarData?.data?.length > 0 ? (
                  calendarData?.data?.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.title}</td>
                      <td>{new Date(item.events_from_date).getFullYear()}</td>
                      <td>
                        <a href={item.upload_image_path} target="_blank">
                          View Document
                        </a>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4}>No Calendar Found</td>
                  </tr>
                )}
              </tbody>
            </Table>

            {/* <div className="pagination-controls">
              <button onClick={() => goToPage(1)} disabled={currentPage === 1}>
                First
              </button>
              <button
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => goToPage(index + 1)}
                  className={currentPage === index + 1 ? "active" : ""}
                >
                  {index + 1}
                </button>
              ))}

              <button
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
              <button
                onClick={() => goToPage(totalPages)}
                disabled={currentPage === totalPages}
              >
                Last
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarPage;
